module.exports = __webpack_public_path__ + "static/media/TQ5.d07b0327.jpg";